import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import {
  getSystemAllRequestsForExport,
  systemAllRequests,
} from "../utilities/utils";

export const _fetchTimesheetCount = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.timesheetCount,
    data: data,
  };
  return await post(request);
};

const getTimesheetPostData = (data) => {
  let candidateRefNo = data.candidateReferenceNo;
  let contractRefNo = data.contractReferenceNo;
  let candidateLicenseNo = data.candidateLicenseNo;
  let candidateId = data.candidateId;
  let complianceStatus = data.complianceStatus;
  let candidateRole = data.candidateRole;
  let candidatePostcode = data.candidatePostcode;
  let sessionType = data.sessionType;
  let lastWorkedDateFrom = data.workedDateFrom;
  let lastWorkedDateTo = data.workedDateTo;
  let contractDateFrom = data.contractDateFrom;
  let contractDateTo = data.contractDateTo;
  let miles = data.miles;
  let search = data.search;
  let currentPage = data.currentPage;
  let timesheetType = data.timesheetType;
  let terminatedBy = data.terminatedBy;
  let terminatedReason = data.terminatedReason;
  let actionedById = data.actionedById;
  let actionedByType = data.actionedByType;
  let sortByColumn = data.sortByColumn;
  let sortByOrder = data.sortByOrder;

  if (candidateId && candidateId.length > 0) {
    candidateId = candidateId.join(",");
  }

  if (terminatedBy && terminatedBy.length > 0) {
    terminatedBy = terminatedBy.join(",");
  }

  if (terminatedReason && terminatedReason.length > 0) {
    terminatedReason = terminatedReason.join(",");
  }

  if (lastWorkedDateFrom && lastWorkedDateFrom !== "") {
    lastWorkedDateFrom = lastWorkedDateFrom.split("/").reverse().join("-");
  }

  if (lastWorkedDateTo && lastWorkedDateTo !== "") {
    lastWorkedDateTo = lastWorkedDateTo.split("/").reverse().join("-");
  }

  if (contractDateFrom && contractDateFrom !== "") {
    contractDateFrom = contractDateFrom.split("/").reverse().join("-");
  }

  if (contractDateTo && contractDateTo !== "") {
    contractDateTo = contractDateTo.split("/").reverse().join("-");
  }

  if (sessionType && sessionType.length > 0) {
    sessionType = sessionType.join(",");
  }

  let postData = {
    candidate_reference_no: candidateRefNo,
    contract_reference_no: contractRefNo,
    candidate_license_no: candidateLicenseNo,
    candidate_id: candidateId,
    candidate_compliance_status: complianceStatus,
    candidate_role: candidateRole,
    candidate_postcode: candidatePostcode,
    sessionType: sessionType,
    last_worked_date_from: lastWorkedDateFrom,
    last_worked_date_to: lastWorkedDateTo,
    contract_date_from: contractDateFrom,
    contract_date_to: contractDateTo,
    miles: miles,
    search: search,
    page: currentPage,
    timesheet_type: timesheetType,
    terminated_by: terminatedBy,
    terminated_reason: terminatedReason,
    actioned_by_id: actionedById,
    actioned_by_type: actionedByType,
    sortByColumn: sortByColumn,
    sortByOrder: sortByOrder,
  };

  return postData;
};

export const _fetchSubmittedTimesheetList = async (data) => {
  let postData = getTimesheetPostData(data);

  systemAllRequests({
    request: postData,
    page: "submitted",
    route: "get_submitted_timesheet_list",
  });
  const request = {
    endPoint: serviceRouteConstants.submittedTimesheetList,
    data: postData,
  };
  return await post(request);
};

export const _fetchAssignedTimesheetList = async (data) => {
  let postData = getTimesheetPostData(data);

  systemAllRequests({
    request: postData,
    page: "assigned",
    route: "get_assigned_timesheet_list",
  });
  const request = {
    endPoint: serviceRouteConstants.assignedTimesheetList,
    data: postData,
  };
  return await post(request);
};

export const _fetchAuthorisedTimesheetList = async (data) => {
  let candidateRefNo = data.candidateReferenceNo;
  let contractRefNo = data.contractReferenceNo;
  let candidateLicenseNo = data.candidateLicenseNo;
  let candidateId = data.candidateId;
  let complianceStatus = data.complianceStatus;
  let candidateRole = data.candidateRole;
  let candidatePostcode = data.candidatePostcode;
  let sessionType = data.sessionType;
  let lastWorkedDateFrom = data.workedDateFrom;
  let lastWorkedDateTo = data.workedDateTo;
  let contractDateFrom = data.contractDateFrom;
  let contractDateTo = data.contractDateTo;
  let miles = data.miles;
  let search = data.search;
  let currentPage = data.currentPage;
  let timesheetType = data.timesheetType;
  let actionedById = data.actionedById;
  let actionedByType = data.actionedByType;
  let sortByColumn = data.sortByColumn;
  let sortByOrder = data.sortByOrder;

  if (lastWorkedDateFrom && lastWorkedDateFrom !== "") {
    lastWorkedDateFrom = lastWorkedDateFrom.split("/").reverse().join("-");
  }
  if (lastWorkedDateTo && lastWorkedDateTo !== "") {
    lastWorkedDateTo = lastWorkedDateTo.split("/").reverse().join("-");
  }
  if (contractDateFrom && contractDateFrom !== "") {
    contractDateFrom = contractDateFrom.split("/").reverse().join("-");
  }
  if (contractDateTo && contractDateTo !== "") {
    contractDateTo = contractDateTo.split("/").reverse().join("-");
  }
  if (sessionType && sessionType.length > 0) {
    sessionType = sessionType.join(",");
  }

  let postData = {
    candidate_reference_no: candidateRefNo,
    contract_reference_no: contractRefNo,
    candidate_license_no: candidateLicenseNo,
    candidate_id: candidateId,
    candidate_compliance_status: complianceStatus,
    candidate_role: candidateRole,
    candidate_postcode: candidatePostcode,
    sessionType: sessionType,
    last_worked_date_from: lastWorkedDateFrom,
    last_worked_date_to: lastWorkedDateTo,
    contract_date_from: contractDateFrom,
    contract_date_to: contractDateTo,
    miles: miles,
    search: search,
    page: currentPage,
    timesheet_type: timesheetType,
    actioned_by_id: actionedById,
    actioned_by_type: actionedByType,
    sortByColumn: sortByColumn,
    sortByOrder: sortByOrder,
  };

  systemAllRequests({
    request: postData,
    page: "authorised",
    route: "get_terminated_timesheet_list",
  });

  //       $allRequest     =   $postData;
  //       $pageOfRequest  =   'authorised';
  //       $crmRoute       =   'get_authorised_timesheet_list';
  //       $method         =   'POST';
  //       ApiHelper::systemAllRequests($allRequest, $pageOfRequest, $crmRoute, $method);

  const request = {
    endPoint: serviceRouteConstants.authorisedTimesheetList,
    data: postData,
  };
  return await post(request);
};

export const _fetchTerminatedTimesheetList = async (data) => {
  let postData = getTimesheetPostData(data);

  systemAllRequests({
    request: postData,
    page: "terminated",
    route: "get_terminated_timesheet_list",
  });
  const request = {
    endPoint: serviceRouteConstants.terminatedTimesheetList,
    data: postData,
  };
  return await post(request);
};

export const _approveAmendment = async (data) => {
  let signoff_ids = data.signoff_id;
  let postData = getSystemAllRequestsForExport(
    data,
    "signoff_ids",
    signoff_ids,
  );
  const request = {
    endPoint: serviceRouteConstants.approveAmendment,
    data: postData,
  };
  return await post(request);
};

export const _rejectAmendment = async (data) => {
  let signoff_ids = data.signoff_id;
  let postData = getSystemAllRequestsForExport(
    data,
    "signoff_ids",
    signoff_ids,
  );
  postData.reason = data.reason;
  const request = {
    endPoint: serviceRouteConstants.rejectAmendment,
    data: postData,
  };
  return await post(request);
};

export const _showAdjustAmendment = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.shotAdjustAmendment,
    data: data,
  };
  return await post(request);
};
export const _saveAdjustAmendment = async (data, _contractAdjustRates) => {
  let postData = {
    signoff_id: data.signOffId,
    start_time: data.startTime,
    end_time: data.endTime,
    break_time: data.breakTime,
    admin_time: data.adminTime,
    no_of_visit: data.noOfVisit,
    contract_adj_rates: JSON.stringify(_contractAdjustRates),
  };
  const request = {
    endPoint: serviceRouteConstants.saveAdjustAmendment,
    data: postData,
  };
  return await post(request);
};

export const _signOffJob = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.signOffJob,
    data,
  };
  return await post(request);
};

export const _getUnPaidTimesheet = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getUnPaidTimesheet,
    data,
  };
  return await post(request);
};

export const _saveInvoiceAdjustment = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.saveInvoiceAdjustment,
    data,
  };
  return await post(request);
};
